import { AppConst } from 'constants/appConst';

/**
 * 利用規約サンプルテキスト内の [クライアント企業名] を会社名に置換して返す。
 * companyName が null / undefined / 空文字の場合は '[クライアント企業名]' のままにする。
 */
export function getTermSampleWithCompanyName(companyName: string | null | undefined): string {
  const name = companyName || '[クライアント企業名]';
  return AppConst.termSample.replace(/\[クライアント企業名\]/g, name);
}
